<template>
    
      <ui-chip v-if='item.status!="approved" && item.status' icon="exclamation-circle" :backgroundColor="getStatusColor(item.status)">
         {{$t('language.'+item.status)}}
      </ui-chip>
   
</template>

<script>
import UiChip from '../UiChip.vue';

export default {
  name: 'news-status-chip',
  props:{
    item:undefined,
  },
  data:function(){
    return {
      
    }
  },
  computed:{
  },
  components:{
    UiChip,
  },
  methods:{
    getStatusColor(status){
      switch(status){
        case "pending": return "#ffbc00"
        case "rejected": return "#FF0000"
        case "approved": return "#03d800"
        case "draft": return "#c5c5c5"
      }
    },
      
  },
  mounted:function(){
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>

